export default "/images/img_14.png?8295e9df0e535351d4bc0183c04af725";